import React from 'react'

const index = () => {
  return (
    <div>Previous projects</div>
  )
}

export default index